(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').config(Config);

  function Config($stateProvider) {
    $stateProvider.state('validoEnviados', {
      url: "/membro/validacao/relatorio",
      templateUrl: 'module/validacao/filtro/enviados.html',
      controller: 'FiltroRelatorio',
      controllerAs: 'vm',
      params: {
        periodoSelecionado: '',
        nomeOrgaoFiltrado: '',
        referer: '',
        promotorSelecionado: '',
        situacaoSelecionada: ''
      }
    })
    ;
  }

})();
